var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentinelOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6572_132969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89003 0.5H10.0741V13.3857H7.89003V0.5ZM10.6032 16.4933L12.7855 15.1589V4.00292C12.1386 3.52951 11.3932 3.20364 10.6032 3.04879V16.4933ZM5.1718 15.1656L7.35585 16.5V3.05546C6.56577 3.20797 5.81983 3.53157 5.1718 4.00292V15.1656ZM13.3147 1.11218V14.9254L14.3289 14.3048C14.6921 14.0691 14.9892 13.7468 15.1928 13.3678C15.3963 12.9888 15.4998 12.5653 15.4936 12.1364V5.61259C15.4987 3.73103 13.3147 1.11218 13.3147 1.11218ZM2.4671 12.1314C2.46044 12.5604 2.56372 12.9841 2.76733 13.3631C2.97094 13.7422 3.2683 14.0644 3.63181 14.2998L4.64608 14.9204V1.11218C4.64608 1.11218 2.4671 3.73103 2.4671 5.61259V12.1314Z",
    fill: "#6B0AEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6572_132969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.980469 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentinelOne);
export default __webpack_public_path__ + "static/media/SentinelOne.012a3021a62fc96b6935d1a56ebc69fd.svg";
export { ForwardRef as ReactComponent };